import { makeStyles } from '@barracuda-internal/bds-core'

export default makeStyles(theme => ({
  formRow: {
    marginBottom: theme.spacing(2)
  },
  error: {
    marginBottom: theme.spacing(2)
  }
}))
